type GameCardDim = {
  [key: string]: { height: string; width: string };
};
const gameCardDim: GameCardDim = {
  '2': {
    height: '169px',
    width: '149px'
  },
  '3': {
    height: '148px',
    width: '96px'
  }
};

type AgeGatingConfig = {
  [key: string]: {
    region: string;
    isoCode: string;
    showAgeGating: boolean;
    ageGroup: { label: string }[];
  };
};

const ageGatingConfig: AgeGatingConfig = {
  br: {
    region: 'BRAZIL',
    isoCode: 'br',
    showAgeGating: false,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  co: {
    region: 'COLUMBIA',
    isoCode: 'co',
    showAgeGating: false,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  mx: {
    region: 'MEXICO',
    isoCode: 'mx',
    showAgeGating: false,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  ar: {
    region: 'ARGENTINA',
    isoCode: 'ar',
    showAgeGating: false,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  pe: {
    region: 'PERU',
    isoCode: 'pe',
    showAgeGating: false,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  cl: {
    region: 'CHILE',
    isoCode: 'cl',
    showAgeGating: false,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  cr: {
    region: 'COSTA RICA',
    isoCode: 'cr',
    showAgeGating: false,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  gt: {
    region: 'GUATEMALA',
    isoCode: 'gt',
    showAgeGating: false,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  us: {
    region: 'US',
    isoCode: 'us',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 13' },
      { label: '14 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  gb: {
    region: 'UK',
    isoCode: 'gb',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },

  in: {
    region: 'INDIA',
    isoCode: 'in',
    showAgeGating: false,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  ca: {
    region: 'CANADA',
    isoCode: 'ca',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 14' },
      { label: '15 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  au: {
    region: 'AUSTRALIA',
    isoCode: 'au',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 18' },
      { label: '19 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  es: {
    region: 'SPAIN',
    isoCode: 'es',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  pl: {
    region: 'POLAND',
    isoCode: 'pl',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  fr: {
    region: 'FRANCE',
    isoCode: 'fr',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  de: {
    region: 'GERMANY',
    isoCode: 'de',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  be: {
    region: 'BELGIUM',
    isoCode: 'be',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 13' },
      { label: '14 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  jp: {
    region: 'JAPAN',
    isoCode: 'jp',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  nl: {
    region: 'NETHERLANDS',
    isoCode: 'nl',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  cz: {
    region: 'CZECH REPUBLIC',
    isoCode: 'cz',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 15' },
      { label: '16 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  sk: {
    region: 'SLOVAKIA',
    isoCode: 'sk',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  se: {
    region: 'SWEDEN',
    isoCode: 'se',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  bg: {
    region: 'BULGARIA',
    isoCode: 'bg',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 14' },
      { label: '15 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  ro: {
    region: 'ROMANIA',
    isoCode: 'ro',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 14' },
      { label: '15 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  rs: {
    region: 'SERBIA',
    isoCode: 'rs',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 15' },
      { label: '16 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  },
  it: {
    region: 'ITALY',
    isoCode: 'it',
    showAgeGating: true,
    ageGroup: [
      { label: '03 to 16' },
      { label: '17 to 30' },
      { label: '31 to 50' },
      { label: '50+' }
    ]
  }
};

export { gameCardDim, type GameCardDim, ageGatingConfig, type AgeGatingConfig };
